module.exports = __webpack_public_path__ + "static/media/check-box-checked-icon.d22d5f19.svg";